export const newsCategories = ["全部", "新闻", "评测", "活动", "专题"];

export const newsList = [
  {
    id: "fall-2026-lineup",
    title: "2026 秋季新番完整片单公开，奇幻与治愈系成最大赢家",
    excerpt:
      "本季共有 58 部新作开播，其中奇幻题材占比接近三成，多部高口碑续作集中在十月下旬上线。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20anime%20illustration%20of%20a%20wall%20of%20colorful%20anime%20posters%20in%20a%20soft%20pink%20lit%20exhibition%20hall%2C%20clean%20composition%2C%20gentle%20depth%20of%20field%2C%20high%20detail&width=900&height=560&seq=sakura-news-fall-lineup&orientation=landscape",
    category: "新闻",
    author: "编辑部 · 星野",
    date: "2026-10-15",
    views: "1.2万",
    tags: ["新番", "片单", "秋季"],
    body: [
      "随着十月档期正式开启，2026 秋季新番的完整片单终于尘埃落定。本季共有 58 部新作与续作开播，是近三年来数量最多的一季，其中奇幻与治愈系作品合计占比接近三成。",
      "从已经播出的前几集来看，原创动画的表现格外亮眼。多部作品选择用低饱和的画面和缓慢的节奏讲故事，与过去几年追求强刺激的路线形成鲜明对比。业内普遍认为，这与观众对「陪伴感」内容的需求上升有关。",
      "续作方面，几部备受期待的作品集中排播在十月下旬，档期竞争相当激烈。多位制作人在采访中提到，本季的制作周期普遍比往年更宽裕，这也让作画质量有了明显保障。",
      "樱花动漫官网已同步更新本季全部作品的详细页面，包括制作阵容、集数信息与更新时间。你可以在动漫分类页按「2026」年份筛选，快速找到自己感兴趣的作品。",
    ],
  },
  {
    id: "frieren-review",
    title: "《葬送的芙莉莲》深度评测：把时间拍成一首安静的长诗",
    excerpt:
      "它没有把冒险当作终点，而是把冒险之后的漫长岁月摊开给你看。这可能是近年最温柔的一部奇幻作品。",
    cover:
      "https://readdy.ai/api/search-image?query=Soft%20painterly%20anime%20scene%20of%20an%20elf%20mage%20sitting%20alone%20on%20a%20grassy%20hill%20watching%20a%20pink%20sunset%20with%20floating%20petals%2C%20warm%20nostalgic%20mood%2C%20wide%20composition%2C%20high%20detail&width=900&height=560&seq=sakura-news-frieren-review&orientation=landscape",
    category: "评测",
    author: "特约评测 · 林深",
    date: "2026-10-12",
    views: "9860",
    tags: ["评测", "奇幻", "高分"],
    body: [
      "大多数冒险故事在魔王倒下的那一刻结束，而《葬送的芙莉莲》恰恰从那里开始。勇者一行凯旋，五十年后，人类老去，精灵依旧年轻，故事才真正展开。",
      "作品最动人的地方，是它对「时间感」的处理。镜头愿意在无意义的日常上停留：一杯热汤、一条走了很多次的路、一句没说完的话。观众和芙莉莲一起，慢慢意识到那些被自己忽略的瞬间，其实是全部意义所在。",
      "作画层面的稳定同样值得称道。战斗戏克制而精准，日常戏的光影处理细腻到近乎奢侈。配乐几乎从不煽情，却在关键处轻轻一推，让人毫无防备地红了眼眶。",
      "如果你最近有点累，想找一部不需要用力、却能安静陪着你走一段的作品，这部值得放进片单最前面。樱花动漫官网已上线全 28 集，支持收藏与剧集切换预览。",
    ],
  },
  {
    id: "studio-interview",
    title: "独家专访：一家小工作室如何做出年度最佳作画",
    excerpt:
      "十二个人的团队，四百多个日夜，一部几乎没有宣传预算的作品。他们聊了聊坚持的理由。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20editorial%20illustration%20of%20a%20small%20anime%20studio%20desk%20with%20drawing%20tablets%2C%20storyboards%2C%20coffee%20cups%20and%20pink%20afternoon%20light%2C%20cozy%20atmosphere%2C%20high%20detail&width=900&height=560&seq=sakura-news-studio-interview&orientation=landscape",
    category: "新闻",
    author: "编辑部 · 阿澈",
    date: "2026-10-09",
    views: "7420",
    tags: ["访谈", "幕后", "制作"],
    body: [
      "在东京郊外一栋旧楼的四层，我们见到了这支只有十二个人的动画团队。房间里堆满了分镜纸，窗台上放着一盆快被养死的绿植，墙上贴着满满的日程表。",
      "「我们没有能力做特别宏大的场面，所以只能把每一个小动作做对。」导演这样说。为了三秒钟的回头镜头，团队画了两百多张原画，反复修改到截止日前一天。",
      "这种近乎固执的做法在当下的行业环境里并不常见。制作人坦言，项目能顺利完成，很大程度上依赖几位核心成员主动延长了工作时间。「不是因为钱，是因为不甘心。」",
      "这部作品最终在评分网站上拿到了超出预期的成绩。采访结束时，导演指着窗外的天空说，下一部想做一个关于夏天的故事。",
    ],
  },
  {
    id: "sakura-festival",
    title: "樱花动漫线上嘉年华开启，超三百份周边等你来抽",
    excerpt:
      "为期两周的线上活动正式启动，参与剧集打卡、收藏作品即可获得抽奖机会，更有声优连线专场。",
    cover:
      "https://readdy.ai/api/search-image?query=Festive%20anime%20illustration%20of%20a%20sakura%20festival%20street%20with%20lanterns%2C%20pink%20petals%20falling%2C%20booths%20and%20glowing%20signs%20at%20dusk%2C%20warm%20joyful%20mood%2C%20high%20detail&width=900&height=560&seq=sakura-news-festival&orientation=landscape",
    category: "活动",
    author: "运营组 · 小满",
    date: "2026-10-06",
    views: "1.6万",
    tags: ["活动", "福利", "抽奖"],
    body: [
      "一年一度的樱花动漫线上嘉年华今天正式开启。从 10 月 6 日到 10 月 20 日，站内将连续两周推出主题活动，包括剧集打卡、收藏抽奖和声优连线专场。",
      "活动期间，只要在动漫详情页完成收藏，即可获得一次抽奖机会，每天最多可累计三次。奖品包括限定周边、纪念徽章与年度会员兑换码，总计超过三百份。",
      "此外，本周六晚八点还将举办一场声优线上连线，聊一聊配音现场的趣事。名额有限，届时会在站内公告区放出参与入口。",
      "提醒大家理性参与，所有活动均为站内演示性质，不涉及任何付费项目。祝你抽到想要的那一份。",
    ],
  },
  {
    id: "anime-tourism",
    title: "取景地巡礼：那些被动画改变的小镇，现在怎么样了",
    excerpt:
      "从海边车站到山顶神社，我们走访了三座因动画而走红的小镇，记录下镜头之外的真实生活。",
    cover:
      "https://readdy.ai/api/search-image?query=Peaceful%20seaside%20japanese%20town%20at%20golden%20hour%20with%20a%20small%20train%20station%2C%20pink%20sky%2C%20utility%20poles%20and%20quiet%20streets%2C%20painterly%20illustration%20style%2C%20high%20detail&width=900&height=560&seq=sakura-news-tourism&orientation=landscape",
    category: "专题",
    author: "专题组 · 川上",
    date: "2026-10-03",
    views: "5320",
    tags: ["专题", "取景地", "旅行"],
    body: [
      "动画里那条通向海边的坡道，现实中只有短短两百米。清晨六点，第一班电车经过时，站台上的风把外套吹得鼓起来，和屏幕上的一模一样。",
      "当地居民告诉我们，游客变多之后，小镇多了两家咖啡馆和一间卖纪念品的小店，但也有老人抱怨人太多，安静的日子变少了。这种矛盾几乎出现在每一个「圣地巡礼」的目的地。",
      "第二站是山中的神社。石阶有三百多级，动画里主角跑上去只用了一个镜头，我们走了将近二十分钟。山顶的视野确实值得，远处的云层被夕阳染成了浅粉色。",
      "旅行的意义或许不在于打卡，而在于你终于亲眼看到，那些被画下来的日常，其实是由许多普通人的生活在支撑着。",
    ],
  },
  {
    id: "voice-actor-trend",
    title: "声优行业观察：新人涌入之后，机会变多了吗",
    excerpt:
      "每年有上千名新人进入声优行业，真正能靠配音养活自己的不足一成。我们和三位从业者聊了聊。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20a%20recording%20studio%20booth%20with%20a%20microphone%20and%20headphones%2C%20soft%20pink%20and%20amber%20lighting%2C%20shallow%20depth%20of%20field%2C%20high%20detail&width=900&height=560&seq=sakura-news-voice-actor&orientation=landscape",
    category: "新闻",
    author: "编辑部 · 星野",
    date: "2026-09-28",
    views: "6140",
    tags: ["声优", "行业", "观察"],
    body: [
      "过去十年，声优学校的招生人数增长了三倍。社交平台的传播让更多人看见这个行业，也让竞争变得前所未有的激烈。",
      "「刚入行的前两年，基本靠打工生活。」一位入行四年的声优告诉我们，配音工作的时间并不固定，很多时候要为一句台词反复录上十几遍。",
      "不过，行业也在变化。随着动画产量增加和海外配音需求上升，稳定的工作机会确实比过去更多。问题在于，这些机会往往集中在少数人身上。",
      "接受采访的三位从业者都提到同一件事：比起一夜爆红，更重要的是找到能长期做下去的方式。这个行业需要的不是热情，而是耐力。",
    ],
  },
  {
    id: "soundtrack-review",
    title: "年度动画原声盘点：十首值得单独循环的曲子",
    excerpt:
      "有些故事在画面结束后才真正开始。这份歌单收录了今年最动人的十首动画配乐。",
    cover:
      "https://readdy.ai/api/search-image?query=Dreamy%20illustration%20of%20a%20grand%20piano%20in%20a%20sunlit%20room%20with%20floating%20sheet%20music%20and%20sakura%20petals%2C%20soft%20pink%20light%2C%20elegant%20composition%2C%20high%20detail&width=900&height=560&seq=sakura-news-soundtrack&orientation=landscape",
    category: "评测",
    author: "特约评测 · 森川",
    date: "2026-09-24",
    views: "8870",
    tags: ["配乐", "歌单", "评测"],
    body: [
      "好的配乐不会抢戏，它只是在你没注意的时候，悄悄把情绪托起来。今年这份盘点里，有几首曲子我们反复听了上百遍。",
      "排在第一位的是某部奇幻作品的片尾曲。整首曲子只用了钢琴和弦乐，主旋律简单到几乎可以哼出来，却在副歌处突然加入一段留白，让人猝不及防地想起剧中的离别。",
      "另外几首来自日常系动画的插曲，篇幅都很短，有的甚至不到两分钟。它们不追求完整，只负责在某个特定的黄昏出现，然后消失。",
      "如果你也有属于自己的「听歌时刻」，不妨戴上耳机，把房间的灯关掉，从第一首开始。音乐比画面更容易把记忆留下来。",
    ],
  },
  {
    id: "chinese-animation-rise",
    title: "国产动画这一年：从技术追赶走向叙事自信",
    excerpt:
      "不再只是炫技，越来越多国产作品开始认真讲故事。这一年的变化，比想象中更明显。",
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20ink%20wash%20illustration%20of%20floating%20mountains%20and%20ancient%20chinese%20architecture%20with%20glowing%20lanterns%2C%20soft%20rose%20and%20jade%20tones%2C%20cinematic%20wide%20composition%2C%20high%20detail&width=900&height=560&seq=sakura-news-cn-animation&orientation=landscape",
    category: "专题",
    author: "专题组 · 南岸",
    date: "2026-09-19",
    views: "1.1万",
    tags: ["国产动画", "专题", "行业"],
    body: [
      "如果说几年前大家对国产动画的评价还集中在「画面进步了」，那么今年，讨论的重点终于转向了故事本身。",
      "从仙侠到科幻，从古风到都市，题材的边界在不断拓宽。更重要的是，创作者开始敢于处理复杂的人物关系，不再急着把每个角色都写成好人。",
      "技术层面的成熟依然是基础。三维与二维的混合制作越来越自然，动作镜头的调度也有了明显的作者风格。但真正留住观众的，仍然是那些说得出口的情感。",
      "当然，问题依旧存在：剧本打磨周期短、系列化运营经验不足、海外发行渠道有限。但至少这一年，我们看到了往前走的方向。",
    ],
  },
  {
    id: "viewing-guide",
    title: "新人入坑指南：从这五部开始，不会踩雷",
    excerpt:
      "第一次看番不知道从哪部开始？这份片单兼顾类型、篇幅与门槛，闭着眼睛选也不会错。",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20illustration%20of%20a%20stack%20of%20anime%20bluray%20cases%20beside%20a%20cup%20of%20tea%20and%20a%20soft%20blanket%20on%20a%20window%20seat%2C%20pink%20afternoon%20light%2C%20high%20detail&width=900&height=560&seq=sakura-news-guide&orientation=landscape",
    category: "专题",
    author: "编辑部 · 阿澈",
    date: "2026-09-14",
    views: "2.3万",
    tags: ["入门", "片单", "推荐"],
    body: [
      "经常有人问：我想开始看动画，但不知道从哪部看起。这个问题其实没有标准答案，但有一些「不容易踩雷」的选择。",
      "如果你想要情绪上的冲击，可以先看《葬送的芙莉莲》。它节奏缓慢，却几乎没有人会不喜欢；如果你偏爱热血与战斗，《咒术回战》的作画会给你足够的理由。",
      "喜欢轻松日常的，可以试试《孤独摇滚！》；想看结构精巧的悬疑，《夏日重现》会让你停不下来；而如果你想感受国产动画的成长，《时光代理人》是个不错的起点。",
      "最后提醒一句：不用急着补完所有经典。找到一部让你愿意在深夜多点开一集的，就已经足够了。",
    ],
  },
];